import { createSelector } from 'reselect'
import isEmpty from 'lodash/isEmpty'
import { createMultipleStatusSelectors } from 'store/utils/selectorHelpers'
import types from './types'

const getPreferencesState = (state) => state.preferences

export const selectPreferences = createSelector(
  [getPreferencesState],
  (preferences) => preferences.data,
)

export const selectStoreLocatorPreferences = createSelector(
  [selectPreferences],
  (preferences) => (preferences ? (preferences.storeLocator || {}) : {}),
)

export const selectStoreId = createSelector(
  [selectPreferences],
  (preferences) => preferences.storeId || null,
)

export const selectFontFamily = createSelector(
  [selectPreferences],
  (data) => {
    if (isEmpty(data)) {
      return []
    }
    return data.font.family
  },
)

export const selectCanvasBackgroundColor = createSelector(
  [selectPreferences],
  ({ canvas }) => (canvas ? canvas.backgroundColor : '#ffffff'),
)

export const selectElementsConfig = createSelector(
  [selectPreferences],
  ({ elements }) => elements || {},
)

export const selectProductCardConfig = createSelector(
  [selectElementsConfig],
  ({ productCard }) => productCard || {},
)

export const {
  selectFetchPreferencesStatus,
} = createMultipleStatusSelectors(types, getPreferencesState)



// WEBPACK FOOTER //
// ./src/store/preferences/selectors.js